import { EnumAsUnion } from '~/utils/enum_as_union';

export enum WidgetTypes {
  ChartWidget = 'ChartWidget',
  ChartTableWidget = 'ChartTableWidget',
  NodeWidget = 'NodeWidget',
  BlocksWidget = 'BlocksWidget',
  MapWidget = 'MapWidget',
  HeatmapWidget = 'HeatmapWidget',
  WindRoseWidget = 'WindRoseWidget',
  TotalDevicesWidget = 'TotalDevicesWidget',
  TotalDevicesTypesWidget = 'TotalDevicesTypesWidget',
  TotalDevicesOnlinePieChartWidget = 'TotalDevicesOnlinePieChartWidget',
  TotalDevicesOnlineColumnChartWidget = 'TotalDevicesOnlineColumnChartWidget',
  RecentAlertsWidget = 'RecentAlertsWidget',
  DevicesOnlineChartWidget = 'DevicesOnlineChartWidget',
  ConnectivityWidget = 'ConnectivityWidget',
  DistributionWidget = 'DistributionWidget'
}

export type WidgetTypesUnionType = EnumAsUnion<typeof WidgetTypes>;
